// menuPermissions.js
export const menuPermissions = [
    // { name: 'Dashboard', value: 'manage_dashboard' },
    {
      name: 'Dashboard',
      value: 'manage_dashboard',
      subPermissions: [
        { name: 'Export', value: 'manage_dashboard.export', default: false }
      ]
    },
    { 
      name: 'Products', 
      value: 'manage_products',
      subPermissions: [
        { name: 'View', value: 'manage_products.view', default: false },
        { name: 'Edit', value: 'manage_products.edit', default: false },
        { name: 'Activate/Deacivate', value: 'manage_products.activate', default: false },
        { name: 'Depot', value: 'manage_products.depot', default: false },
        { name: 'Product Import', value: 'manage_products.productimport', default: false },
        { name: 'Price Band Import', value: 'manage_products.pricebandimport', default: false },
        { name: 'Export Active Price Band', value: 'manage_products.export', default: false }
      ]
    },
    /*{
      name: 'Request Product Access',
      value: 'manage_product_access_request',
      subPermissions: [
        { name: 'Approve', value: 'manage_product_access_request.approve', default: false },
        { name: 'Export', value: 'manage_product_access_request.export', default: false }
      ]
    },*/
    { 
      name: 'Free Products Setup', 
      value: 'manage_freeproducts',
      subPermissions: [
        { name: 'View', value: 'manage_freeproducts.view', default: false },
        { name: 'Edit', value: 'manage_freeproducts.edit', default: false }
      ]
    },
    { 
      name: 'New Products', 
      value: 'manage_newproducts',
      subPermissions: [
        { name: 'View', value: 'manage_newproducts.view', default: false },
        { name: 'Add', value: 'manage_newproducts.add', default: false },
        { name: 'Edit', value: 'manage_newproducts.edit', default: false },
        { name: 'Delete', value: 'manage_newproducts.delete', default: false }
      ]
    },
    { 
      name: 'Promotion Banner', 
      value:'manage_promotions',
      subPermissions: [
        { name: 'View', value: 'manage_promotions.view', default: false },
        { name: 'Add', value: 'manage_promotions.add', default: false },
        { name: 'Edit', value: 'manage_promotions.edit', default: false },
        { name: 'Delete', value: 'manage_promotions.delete', default: false }
      ]
    },
    { 
      name: 'Promo Offers', 
      value:'manage_promooffers',
      subPermissions: [
        { name: 'View', value: 'manage_promooffers.view', default: false },
        { name: 'Add', value: 'manage_promooffers.add', default: false },
        { name: 'Edit', value: 'manage_promooffers.edit', default: false },
        { name: 'Delete', value: 'manage_promooffers.delete', default: false }
      ]
    },
    { 
      name: 'Customers', 
      value: 'manage_customers',
      subPermissions: [
        { name: 'View', value: 'manage_customers.view', default: false },
        { name: 'Edit', value: 'manage_customers.edit', default: false },
        { name: 'Reset Password', value: 'manage_customers.resetpassword', default: false },
        { name: 'Activate/Deacivate', value: 'manage_customers.activate', default: false },
        { name: 'Session Delete', value: 'manage_customers.delete', default: false },
        { name: 'Import', value: 'manage_customers.import', default: false },
        { name: 'Export', value: 'manage_customers.export', default: false }
      ]
    },
    {
      name: 'Food Service Partners',
      value: 'manage_foodservicepartners',
      subPermissions: [
        { name: 'View', value: 'manage_foodservicepartners.view', default: false },
        { name: 'Add', value: 'manage_foodservicepartners.add', default: false },
        { name: 'Edit', value: 'manage_foodservicepartners.edit', default: false },
        { name: 'Log' , value: 'manage_foodservicepartners.log', default: false },
        { name: 'Delete', value: 'manage_foodservicepartners.delete', default: false },
        { name: 'Refresh', value: 'manage_foodservicepartners.refresh', default: false },
        { name: 'FAQ Reorder', value: 'manage_foodservicepartners.reorder', default: false },
        { name: 'Export', value: 'manage_foodservicepartners.export', default: false }

      ]
    },
    { 
      name: 'Orders', 
      value: 'manage_orders',
      subPermissions: [
        { name: 'View', value: 'manage_orders.view', default: false },
        { name: 'Logs', value: 'manage_orders.logs', default: false },
        { name: 'Refresh', value: 'manage_orders.refresh', default: false },
        { name: 'Export', value: 'manage_orders.export', default: false } ,
        { name: 'Kitchen Orders', value: 'manage_orders.kitchen', default: false } 
      ]
    },
    { name: 'Food Solutions', value:'manage_foodsolutions'},
    { name: 'Stripe Payment Log', value:'manage_stripelog'},
    { 
      name: 'Master Entry', 
      value: 'manage_masterentry' ,
      subPermissions: [
        { name: 'View', value: 'manage_masterentry.view', default: false },
        { name: 'Add', value: 'manage_masterentry.add', default: false },
        { name: 'Edit', value: 'manage_masterentry.edit', default: false },
        { name: 'Delete', value: 'manage_masterentry.delete', default: false },
      ]
    },
    { 
      name: 'Development Chef', 
      value:'manage_chefs',
      subPermissions: [
        { name: 'View', value: 'manage_chefs.view', default: false },
        { name: 'Add', value: 'manage_chefs.add', default: false },
        { name: 'Edit', value: 'manage_chefs.edit', default: false },
        { name: 'Delete', value: 'manage_chefs.delete', default: false }
      ]
    },
    { 
      name: 'Head Office', 
      value:'manage_ho',
      subPermissions: [
        { name: 'View', value: 'manage_ho.view', default: false },
        { name: 'Add', value: 'manage_ho.add', default: false },
        { name: 'Edit', value: 'manage_ho.edit', default: false },
        { name: 'Delete', value: 'manage_ho.delete', default: false }
      ]
    },
    { 
      name: 'Add Users', 
      value: 'manage_users',
      subPermissions: [
        { name: 'View', value: 'manage_users.view', default: false },
        { name: 'Add', value: 'manage_users.add', default: false },
        { name: 'Edit', value: 'manage_users.edit', default: false },
      ]
    },
    { 
      name: 'Add Roles', 
      value: 'manage_roles',
      subPermissions: [
        { name: 'View', value: 'manage_roles.view', default: false },
        { name: 'Add', value: 'manage_roles.add', default: false },
        { name: 'Edit', value: 'manage_roles.edit', default: false },
        { name: 'Delete', value: 'manage_roles.delete', default: false },
      ]
    },
    { 
      name: 'Email Campaign', 
      value:'manage_emailcampaign',
      subPermissions: [
        { name: 'View', value: 'manage_emailcampaign.view', default: false },
        { name: 'Add', value: 'manage_emailcampaign.add', default: false },
        { name: 'Edit', value: 'manage_emailcampaign.edit', default: false },
        { name: 'Delete', value: 'manage_emailcampaign.delete', default: false },
        { name: 'Activate/Deacivate', value: 'manage_emailcampaign.activate', default: false },
        { name: 'Email Logs', value: 'manage_emailcampaign.logs', default: false },
        { name: 'Trigger Emails', value: 'manage_emailcampaign.runemail', default: false },
        { name: 'Export', value: 'manage_emailcampaign.export', default: false },
      ]
    },
    { 
      name: 'Settings', 
      value: 'manage_settings',
      subPermissions: [
        { name: 'View', value: 'manage_settings.view', default: false },
        { name: 'Add', value: 'manage_settings.add', default: false },
        { name: 'Edit', value: 'manage_settings.edit', default: false },
        { name: 'Delete', value: 'manage_settings.delete', default: false },
      ]
    },
  ];